<template>
  <div>
    <div class="controls">
      <p></p>
      <h4 class="text-center">
        {{ title }}
      </h4>
      <section>
        <span class="mx-1">Zoom: {{ scale * 100 - 20 }}%</span>
        <button @click="zoomOut">
          <v-icon>
            mdi-minus
          </v-icon>
        </button>
        <button @click="zoomIn">
          <v-icon>
            mdi-plus
          </v-icon>
        </button>
      </section>
    </div>
    <div class="pdf-container">
      <div ref="pdfViewer"></div>
    </div>
  </div>
</template>

<script>
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import pdfWorker from "pdfjs-dist/legacy/build/pdf.worker.entry";

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: "PDF",
    },
  },
  data() {
    return {
      pdf: null,
      scale: 1.2,
    };
  },
  mounted() {
    this.loadPdf();
  },
  methods: {
    async loadPdf() {
      try {
        const loadingTask = pdfjsLib.getDocument(this.src);
        this.pdf = await loadingTask.promise;
        this.renderAllPages();
      } catch (error) {
        console.error("Error al cargar el PDF:", error);
      }
    },
    async renderAllPages() {
      if (!this.pdf) return;

      const viewer = this.$refs.pdfViewer;
      if (viewer) {
        viewer.innerHTML = "";
        for (let pageNum = 1; pageNum <= this.pdf.numPages; pageNum++) {
          const page = await this.pdf.getPage(pageNum);
          const viewport = page.getViewport({ scale: this.scale });

          const canvas = document.createElement("canvas");
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          viewer.appendChild(canvas);

          const context = canvas.getContext("2d");
          const renderContext = {
            canvasContext: context,
            viewport,
          };

          await page.render(renderContext).promise;
        }
      }
    },
    zoomIn() {
      this.scale += 0.2;
      this.renderAllPages();
    },
    zoomOut() {
      if (this.scale > 0.5) {
        this.scale -= 0.2;
        this.renderAllPages();
      }
    },
  },
};
</script>

<style scoped>
.pdf-container {
  width: 100%;
  height: 880px;
  overflow-y: auto;
  border: 1px solid #ccc;
}

.controls {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

button {
  padding: 5px 5px;
  cursor: pointer;
}
</style>
